<div class="projects-summary-item" [ngClass]="{'summary-opened': opened}" (mouseleave)="onStagesMouseLeave()">
  <div class="summary-item-content">
    <div class="summary-group-id">
      <span class="group-id" title="Open project" (click)="toogleDetails()">
        <span class="id">#{{project.id}}</span>
        <span class="arrow-marker"  [ngClass]="{'arrow-marker-open': opened,'arrow-marker-closed': !opened}"></span>
      </span>
    </div>
    <div class="summary-group-labels">
      <span class="plus" [hidden]="diffLabels.length==0 || diffLabels.length==project.labels.length">+ </span>
      <core-labels-text [labels]="diffLabels" *ngIf="!areLabelsObserved"></core-labels-text>
      <!-- list component only displayed when is set the action for labels select on click -->
      <core-labels-list [labels]="diffLabels" *ngIf="areLabelsObserved" (choose)="onLabelSelect($event)"></core-labels-list>
    </div>
    <div class="summary-group-version">
      <div class="summary-g-version-main">
        <span class="origin">{{project.origin_version != null ? project.origin_version.version : '0.0'}}</span>
        <span class="target">({{project.target_version != null ? project.target_version.version : '0.0'}})</span>
      </div>
    </div>
    <div class="summary-group-assignee">
      <span>{{project.user_assigned != null ? project.user_assigned.name : 'N/A'}}</span>
    </div>
    <div class="summary-group-duedate">
      <span>{{project.due_date != null ? (project.due_date | date: 'dd MMM yyyy'): 'N/A'}}</span>
    </div>

    <!-- TODO: Add classes:  'with-badge' to .summary-group-stage and .summary-group-stage-mobile and the class .badge_artwork / .badge_new_request / .badge_status_update when notifications  -->

    <div class="summary-group-stage"
      (mouseover)="displayOpen=true"
      (mouseout)="displayOpen=false"
      [ngStyle]="{ 'background-color': project.status.color }"
      [ngClass]="[ badge != ''  ? 'with-badge '+badge : '']" 
      (mousedown)="onMouseDown()"
      (mouseup)="onMouseUp()"
      (mouseleave)="onMouseLeave()"
      (click)="onOpen()"
    >
    <span>
      <em [hidden]="displayOpen">{{project.status.name}}</em>
      <em class="summary-item" ><strong [hidden]="!displayOpen || accessLoading">OPEN</strong></em>
      <em class="summary-item wait" ><strong [hidden]="!displayOpen || !accessLoading ">...</strong></em>
    </span>
  </div>
<!-- HERE GOES THE STAGES -->
  <div class="projects-summary-next-stages" 
    *ngIf="displayStages" 
    (mouseleave)="onStagesMouseLeave()" >
    <core-projects-next-stages-menu 
      *ngIf="!accessLoading"
      [nextStages]="nextStages"
      (actionStageClick)="onStageClick($event)"
    ></core-projects-next-stages-menu>
  </div>
  <!-- -->
  <div class="summary-group-mobile">
    <div class="summary-group-stage-mobile"
      [ngStyle]="{ 'background-color': project.status.color }"
      [ngClass]="[ badge != ''  ? 'with-badge '+badge : '']">
      <span>
        <em [hidden]="displayOpen">{{project.status.name}}</em>
      </span>
    </div>
    <div class="summary-group-stage-open" (click)="onOpen()">
      <span>
        <em>OPEN</em>
      </span>
    </div>
  </div>
</div>
</div>
